import { RequireProjectAdmin } from '@front/components/auth/RequireProjectAdmin';
import { createFileRoute } from '@tanstack/react-router';

import { TableDefinitionNewPage } from './new/index';

export const Route = createFileRoute('/table-definitions/new')({
  validateSearch: (search): { sourceSystemId?: string } => ({
    sourceSystemId: typeof search.sourceSystemId === 'string' ? search.sourceSystemId : undefined,
  }),
  component: () => (
    <RequireProjectAdmin>
      <TableDefinitionNewPage />
    </RequireProjectAdmin>
  ),
});
